import EllipsisHorizontal from './EllipsisHorizontal'

export default EllipsisHorizontal
// eslint-disable-next-line import/export
export * from './EllipsisHorizontal'
